import React, { useState, useEffect } from "react";

export default function TenantForm({ tenant, onSubmit, onCancel }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
  });

  useEffect(() => {
    if (tenant) {
      setForm({
        name: tenant.name || "",
        email: tenant.email || "",
      });
    } else {
      setForm({ name: "", email: "" });
    }
  }, [tenant]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (typeof onSubmit !== "function") return;

    onSubmit(form);
  };

  return (
    <form onSubmit={handleSubmit} style={{ marginTop: "1rem" }}>
      <input
        placeholder="Name"
        value={form.name}
        onChange={(e) => setForm({ ...form, name: e.target.value })}
      />

      <input
        placeholder="Email"
        value={form.email}
        onChange={(e) => setForm({ ...form, email: e.target.value })}
      />

      <div style={{ marginTop: "0.5rem" }}>
        <button type="submit">
          {tenant ? "Update" : "Add"}
        </button>

        <button type="button" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </form>
  );
}